<template>
  <section id="tags">
    <div class="demo">
      <h5>Basic</h5>
      <ul class="tags" aria-label="tags">
        <li>HTML</li>
        <li>CSS</li>
        <li>Javascript</li>
      </ul>
      <h5>Removable</h5>
      <ul class="tags" aria-label="tags">
        <li>User Experience Design
          <button type="button" aria-label="remove">
            <i class="gel-icon-close"></i>
          </button>
        </li>
        <li>Graphic Design
          <button type="button" aria-label="remove">
            <i class="gel-icon-close"></i>
          </button>
        </li>
        <li>User Interface Design
          <button type="button" aria-label="remove">
            <i class="gel-icon-close"></i>
          </button>
        </li>
      </ul>
      <h5>Linkable</h5>
      <ul class="tags" aria-label="tags">
        <li>
          <a href="#">Job</a>
        </li>
        <li>
          <a href="#">Profile</a>
        </li>
        <li>
          <a href="#">Onboarding</a>
        </li>
        <li class="active">
          <a href="#">hightlighted</a>
        </li>
      </ul>
    </div>
        <section class="md" v-html="mdfile"></section>
  </section> 
</template>

<script>
import mdfile from "@/docs/components/tags.md";
export default {
  name: "tags",
  beforeCreate: function () {
    this.$emit("update-title", this.$root.yamlData.components.tags.name);
    this.$emit("update-tagline", this.$root.yamlData.components.tags.description);
  },
  data() {
    return {
      mdfile
    };
  }
};
</script>
